export interface CaptureFlow {
  capture: CaptureSide;
}

export interface CaptureSide {
  fileName: string;
  recName: string;
  photoType: CaptureUploadTypes;
  recType: CaptureUploadTypes;
  imageSize: number;
  videoSize: number;
}

export enum CaptureUploadTypes {
  IdFront = 'IdFront',
  IdBack = 'IdBack',
  IdFrontVideo = 'IdFrontVideo',
  IdBackVideo = 'IdBackVideo',
  Selfie = 'Selfie',
  SelfieVideo = 'SelfieVideo',
  SelfieGestureVideo = 'SelfieGestureVideo',
  TiltVideo = 'TiltVideo',
  None = 'None',
}
